/* tslint:disable */
import type * as ApiTypes from '@ogm3/server-types';
import * as Fetch from '../../fetch';
import type * as Actions from '../../async-actions';

// ManageCustomersController

/**
 * Authorize: Policy = "ManageCustomers"
 */
export function GetEditCustomerPage(
	customerId: number
): Promise<Actions.ApiResult<ApiTypes.GetEditCustomerPageResult>> {
	const uri = `/api/v3/syscoselfservice/customers/edit-customer-page?customerId=${customerId}`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'GET',
	};
	return Fetch.fetch2<ApiTypes.GetEditCustomerPageResult>(config);
}

/**
 * Authorize: Policy = "ManageCustomers"
 */
export function SaveCustomerAttributes(
	args: ApiTypes.SaveCustomerAttributesArgs
): Promise<Actions.ApiResult<ApiTypes.SaveCustomerAttributesResult>> {
	const uri = `/api/v3/syscoselfservice/customers/save-customer-attrs`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'POST',
		body: JSON.stringify(args),
	};
	return Fetch.fetch2<ApiTypes.SaveCustomerAttributesResult>(config);
}

/**
 * Authorize: Policy = "ManageCustomers"
 */
export function EnableCustomCategorySetting(
	args: ApiTypes.EnableCustomCategorySettingArgs
): Promise<Actions.ApiResult<ApiTypes.EnableCustomCategorySettingResult>> {
	const uri = `/api/v3/syscoselfservice/customers/enable-custom-category`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'POST',
		body: JSON.stringify(args),
	};
	return Fetch.fetch2<ApiTypes.EnableCustomCategorySettingResult>(config);
}
